module.exports = __webpack_public_path__ + "img/poor.00698722.svg";